import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { getRevenueCentersDisplay } from 'utils/customTendersDrawer/getRevenueCentersDisplay'

const ListItem = ({ customPaymentType }) => {
  const { displayName, active, uuid, revenueCenters } =
    customPaymentType
  const history = useHistory()
  const revenueCentersDisplay = getRevenueCentersDisplay(revenueCenters)

  const onCustomTenderClick = () =>
    history.push({ state: { customTenderUuid: uuid } })

    return (
      <div className="item">
        <div
          className="row"
          onClick={onCustomTenderClick}
          role="button"
        >
          <div className="item-info-wrapper -bold">{displayName}</div>
          <div className="item-info-wrapper">{revenueCentersDisplay}</div>
          <div className="item-info-wrapper">
            <div className="item-type">
              {!active ? (
                <>
                  <span className="item-type__dot -off"></span>
                  <p>Inactive</p>
                </>
              ) : (
                <>
                  <span className="item-type__dot -on"></span>
                  <p>Active</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
}

ListItem.propTypes = {
  customPaymentType: PropTypes.object,
}

export default ListItem
